import React from "react";
import * as PropTypes from "prop-types";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import SubsidizedPricesAsShareOfNonSubsidizedPriceTable from "./SubsidizedPricesAsShareOfNonSubsidizedPriceTable";

const SubsidizedPricesAsShareOfNonSubsidizedPriceTableWidget = props => (
  <DataViewerFrame
    reference="Table 3.2"
    title="Sub Prices as Share of Non-Sub"
    subtitle="Regional Averages among LMICs"
    onDownloadCsv={props.onDownloadCsv}
  >
    <SubsidizedPricesAsShareOfNonSubsidizedPriceTable na="&#8212;" />
  </DataViewerFrame>
);

SubsidizedPricesAsShareOfNonSubsidizedPriceTableWidget.propTypes = {
  onDownloadCsv: PropTypes.func.isRequired
};

export default SubsidizedPricesAsShareOfNonSubsidizedPriceTableWidget;
